import React, { useContext, useState } from "react";
import { Button, Select, WindmillContext } from "@windmill/react-ui";

import Error from "../components/form/Error";
import InputArea from "../components/form/InputArea";
import useLoginSubmit from "../hooks/useLoginSubmit";
import ImageLight from "../assets/img/login_bckground.svg";
import ImageDark from "../assets/img/login_bckground.svg";
import digi_white from "../assets/img/digi_white.png";
import digi_blue from "../assets/img/digi_blue.png";

import PhoneInput, { isPossiblePhoneNumber } from "react-phone-number-input";
import UserServices from "../services/UserServices";
import useAsync from "../hooks/useAsync";

import OtpInput from "react-otp-input";
import { Controller } from "react-hook-form";
import { useCountdown } from "../hooks/useCountdown";
import { AdminContext } from "../context/AdminContext";

const now = new Date();
const addTwoMinutes = new Date(now.getTime() + 2 * 60000);

const CountDown = ({ timeLeft, didntReceiveCode }) => {
  const [day, hours, minutes, seconds] = useCountdown(timeLeft);

  return (
    <div className="flex justify-center mt-4">
      {minutes + seconds <= 0 ? (
        <p className="mr-2">0 : 00</p>
      ) : (
        <p className="mr-2 dark:text-white">
          {minutes} {":"} {seconds}
        </p>
      )}

      <button
        disabled={minutes + seconds > 0}
        onClick={didntReceiveCode}
        className={`${
          minutes + seconds <= 0 ? "text-green-500" : "text-gray-500"
        } font-thin`}
      >
        I didn't receive the code
      </button>
    </div>
  );
};

const SignUp = () => {
  const { mode, toggleMode } = useContext(WindmillContext);
  const { state, dispatch } = useContext(AdminContext);
  const {
    onboardUser,
    register,
    handleSubmit,
    errors,
    setValue,
    loading,
    registerUser,
    control,
    didntReceiveCode,
    validateOTP,
  } = useLoginSubmit();

  const { data: onboardingRequirements } = useAsync(
    () => UserServices.getOnboardingRequirements(),
    {}
  );

  const { business_category, business_segments, countries, channels } =
    onboardingRequirements;

  const [step, setStep] = useState(1);
  const [timeLeft, setTimeLeft] = useState(addTwoMinutes);

  return (
    <div className="flex items-center bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col-reverse overflow-y-auto lg:flex-row w-full">
        <div className="h-[60vh] md:h-[40vh] lg:h-screen lg:w-7/12 xl:w-1/2 relative">
          <div
            className="absolute left-0 top-0 h-full w-full bg-[#204391]"
            style={{
              // mixBlendMode: "multiply",
              opacity: "73%",
            }}
          />
          <img
            aria-hidden="true"
            className="object-cover w-full h-[60vh] md:h-[40vh] lg:h-screen dark:hidden"
            src={ImageLight}
            alt="Office"
          />
          <img
            aria-hidden="true"
            className="hidden object-cover w-full h-[60vh] md:h-[40vh] lg:h-screen dark:block"
            src={ImageDark}
            alt="Office"
          />

          <div className="flex flex-col justify-end lg:justify-around w-full items-center absolute z-50 top-0 left-0 h-full">
            {/* <button onClick={() => toggleMode()}>toggle</button> */}
            <div className="w-10/12 md:w-8/12 xl:w-7/12 2xl:w-1/2 hidden lg:flex">
              <img
                aria-hidden="true"
                className="w-[170px]"
                src={digi_white}
                alt="digi_white"
              />
            </div>
            <div className="w-10/12 md:w-8/12 xl:w-7/12 2xl:w-1/2">
              <h1 className="text-white text-4xl xl:text-6xl leading-snug lg:leading-snug tracking-wider lg:tracking-widest">
                Manage your business today with{" "}
                <span className="text-green-500">Digistore</span>
              </h1>

              <p className="text-white mt-8 tracking-wider leading-loose">
                Join our family of over 5,000+ businesses and partners who
                manage their sales, receive payments, manage their products,
                inventory and many more all in ONE account.
              </p>
            </div>

            <div className="flex w-10/12 md:w-8/12 xl:w-7/12 2xl:w-1/2 items-center">
              <a
                href="https://play.google.com/store/apps/details?id=com.ipayghpos"
                target={"_blank"}
                rel="noreferrer"
              >
                <div className="w-[80px] lg:w-[120px] lg:h-[120px] h-[70px] flex items-center">
                  <img
                    src={
                      "https://storage.googleapis.com/static.digistoreafrica.com/appClassic/" +
                      "google-play-badge.png"
                    }
                    alt={"google"}
                    className="rounded-lg"
                  />
                </div>
              </a>

              <a
                href="https://apps.apple.com/gh/app/digistore-business-manager/id6449488981"
                target={"_blank"}
                rel="noreferrer"
              >
                <div className="w-[80px] lg:w-[120px] lg:h-[120px] ml-[15px] h-[70px] flex items-center">
                  <img
                    src={
                      "https://storage.googleapis.com/static.digistoreafrica.com/appClassic/" +
                      "app-store-badge.png"
                    }
                    alt={"iphone"}
                    className="rounded-lg"
                  />
                </div>
              </a>

              <a
                href="https://pos.digistoreafrica.com"
                target={"_blank"}
                rel="noreferrer"
              >
                <div className="w-[80px] lg:w-[112px] lg:h-[120px] ml-[15px] h-[70px] flex items-center">
                  <img
                    src={
                      "https://storage.googleapis.com/static.digistoreafrica.com/appClassic/" +
                      "pc.png"
                    }
                    alt={"pc"}
                    className="rounded-lg"
                  />
                </div>
              </a>
            </div>

            <div className="flex w-10/12 md:w-8/12 xl:w-7/12 2xl:w-1/2 items-center dark:text-white text-gray-300">
              <p>© 2020 - {new Date().getFullYear()} iPay Solutions Limited</p>
            </div>
          </div>
        </div>

        <main className="sub-scroll lg:h-screen overflow-y-scroll flex items-center justify-start p-10 sm:p-12 xl:w-5/12">
          <div className="w-full xl:w-7/12">
            <div className="justify-center mb-4 lg:hidden flex">
              <img
                aria-hidden="true"
                className="w-[170px]"
                src={digi_blue}
                alt="digi_blue"
              />
            </div>
            <h1 className="text-center lg:text-left mb-6 text-2xl font-semibold text-[#204391]">
              Create your ONE Account{" "}
            </h1>
            <p className="text-center lg:text-left text-gray-500 dark:text-white">
              Welcome. Create ONE Account to manage your sales, inventory,
              payments
            </p>
            <form
              className="mt-10"
              onSubmit={handleSubmit((values) => {
                if (step === 1) {
                  registerUser({
                    values,
                    nextAction: () => setStep((data) => data + 1),
                  });
                }

                if (step === 2) {
                  validateOTP({
                    values,
                    nextAction: () => setStep((data) => data + 1),
                  });
                }

                if (step === 3) {
                  onboardUser(values);
                }
              })}
            >
              {step === 1 && (
                <div className="w-full mb-3">
                  <div className="flex justify-center w-full">
                    <div className="w-full">
                      <p className="text-sm text-gray-700 dark:text-white text-left mb-6">
                        Enter your Mobile Number to Get Started
                      </p>
                      <PhoneInput
                        international={true}
                        withCountryCallingCode={true}
                        defaultCountry="GH"
                        placeholder="Mobile Number"
                        {...register("contact_phone", {
                          required: "Mobile number is required",
                          validate: {
                            validNumber: (value) =>
                              isPossiblePhoneNumber(value) ||
                              "Number is not valid",
                          },
                        })}
                        onChange={(value) =>
                          setValue("contact_phone", value, {
                            shouldValidate: true,
                          })
                        }
                      />
                    </div>
                  </div>
                  <Error errorName={errors?.contact_phone} />
                </div>
              )}

              {step === 2 && (
                <>
                  <div className="">
                    <p className="text-sm text-gray-500 dark:text-white text-center mb-3 px-6">
                      For security, help us ensure only you can log in into your
                      account
                      <br></br>
                      <br></br>
                      Enter the 6-digit code sent to you at:
                      <b>{state?.userRegisterDetails?.contact_phone}</b>
                    </p>
                  </div>
                  <div className="w-full mb-3 ">
                    <div className="flex justify-center">
                      <Controller
                        control={control}
                        name="otp"
                        rules={{
                          required: {
                            value: true,
                            message: `OTP is required`,
                          },
                          minLength: {
                            value: 6,
                            message: "OTP must have length of 6",
                          },
                          maxLength: {
                            value: 6,
                            message: "OTP must have length of 6",
                          },
                        }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <>
                            <OtpInput
                              isInputNum
                              value={value}
                              onChange={(otp) => onChange(otp)}
                              numInputs={6}
                              separator={<span>-</span>}
                              inputStyle={{
                                borderColor: "black",
                                borderWidth: 1,
                                borderRadius: 2,
                                height: 40,
                                width: 40,
                              }}
                              hasErrored={!!errors?.otp?.message}
                              shouldAutoFocus={true}
                              isDisabled={loading}
                              errorStyle={{
                                borderColor: "red",
                                borderWidth: 1,
                              }}
                            />
                          </>
                        )}
                      />
                    </div>
                    <div className="flex w-full justify-center mt-1">
                      <Error errorName={errors?.otp} />
                    </div>
                    <CountDown
                      timeLeft={timeLeft}
                      didntReceiveCode={() => didntReceiveCode({ setTimeLeft })}
                    />
                  </div>
                </>
              )}

              {step === 3 && (
                <>
                  <div className="my-3">
                    <InputArea
                      register={register}
                      label="Business Trading Name"
                      name="buss_name"
                      type="text"
                      placeholder="Business Trading Name"
                    />
                    <Error errorName={errors.buss_name} />
                  </div>
                  <div className="my-3">
                    <InputArea
                      register={register}
                      label="First and Last name"
                      name="contact_name"
                      type="text"
                      placeholder="First and Last name"
                    />
                    <Error errorName={errors.contact_name} />
                  </div>
                  <div className="my-3">
                    <InputArea
                      required
                      register={register}
                      label="Email"
                      name="contact_email"
                      type="email"
                      placeholder="Email (Optional)"
                    />
                    <Error errorName={errors.contact_email} />
                  </div>

                  <div className="my-3">
                    <InputArea
                      required
                      register={register}
                      label="Referral Code"
                      name="sales_referal"
                      type="text"
                      placeholder="Referral Code (Optional)"
                    />
                  </div>
                  <div className="my-3">
                    <Select
                      className="text-gray-500 border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-transparent border-transparent focus:bg-white"
                      name={`buss_segment`}
                      {...register(`buss_segment`, {
                        required: `Business segment is required!`,
                      })}
                    >
                      <option value="" defaultValue="">
                        Which best describes your business?
                      </option>
                      {business_segments?.map((s) => {
                        return (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        );
                      })}
                    </Select>
                    <Error errorName={errors.buss_segment} />
                  </div>
                  {/* <div className="my-3">
                    <Select
                      className="text-gray-500 border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-transparent border-transparent focus:bg-white"
                      name={`buss_segment`}
                      {...register(`buss_segment`, {
                        required: `Business segment is required!`,
                      })}
                    >
                      <option value="" defaultValue="">
                        Which best describes your business?
                      </option>
                      {business_category?.map((business_category) => {
                        return (
                          <option
                            key={business_category?.category_id}
                            value={business_category?.category_id}
                          >
                            {business_category?.category_name}
                          </option>
                        );
                      })}
                    </Select>
                    <Error errorName={errors.buss_segment} />
                  </div> */}

                  <div className="my-3">
                    <Select
                      className="text-gray-500 border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-transparent border-transparent focus:bg-white"
                      name={`buss_country`}
                      {...register(`buss_country`, {
                        required: `Business country is required!`,
                      })}
                    >
                      <option value="" defaultValue="">
                        Where is your business located?
                      </option>
                      {countries?.map((country) => {
                        return (
                          <option key={country?.code} value={country?.code}>
                            {country?.name}
                          </option>
                        );
                      })}
                    </Select>
                    <Error errorName={errors.buss_country} />
                  </div>
                  <div className="my-3">
                    <Select
                      className="text-gray-500 border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-transparent border-transparent focus:bg-white"
                      name={`sales_channel`}
                      {...register(`sales_channel`, {
                        required: `Channel is required!`,
                      })}
                    >
                      <option value="" defaultValue="">
                        How did you hear about us?
                      </option>
                      {channels?.map((channel) => {
                        return (
                          <option key={channel} value={channel}>
                            {channel}
                          </option>
                        );
                      })}
                    </Select>
                    <Error errorName={errors.sales_channel} />
                  </div>

                  <div className="w-full flex items-start text-gray-500 dark:text-white text-sm my-4">
                    <input
                      className="mr-2"
                      type="checkbox"
                      {...register("accept_terms", {
                        required: `Please accept terms`,
                      })}
                    />
                    <p>
                      By clicking to create an account, you agree to iPay's{" "}
                      <a
                        className="underline"
                        href="https://business.digistoreafrica.com/terms/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Terms of Use
                      </a>{" "}
                      and{" "}
                      <a
                        className="underline"
                        href="https://business.digistoreafrica.com/privacy/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </p>
                  </div>
                  <Error errorName={errors.accept_terms} />
                </>
              )}

              <Button
                disabled={loading}
                type="submit"
                className="mt-4 h-12 w-full"
                block
              >
                {step === 1 && "Get Started"}
                {step === 2 && "Verify Code"}
                {step === 3 && "Sign up"}
              </Button>

              {step === 2 && (
                <div className="flex w-full justify-center mt-3">
                  <button
                    className="text-green-500 font-semibold text-xs"
                    onClick={() => {
                      setStep(1);
                    }}
                  >
                    I want to change my number
                  </button>
                </div>
              )}
            </form>

            <button
              onClick={() => {
                window.open("https://pos.digistoreafrica.com", "_self");
              }}
              className="mt-10 text-sm font-medium dark:text-white text-gray-500"
              to="/login"
            >
              Already have an account?{" "}
              <span className=" text-green-500 dark:text-green-400 hover:underline">
                Login
              </span>
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SignUp;
